@if (!(accountService.currentAccount | async )) {
  <div>
    <app-email-login></app-email-login>
  </div>
}

@if (accountService.currentAccount | async; as user) {
  <div>
    <mat-card>
      <mat-card-header>
        <mat-card-title>
          Signed in as <strong>{{ user.email }}</strong>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        Connect a scale to collect waste, compost, and recycling weights and locations by choosing <strong>Record Data</strong>.
      </mat-card-content>
      <mat-card-actions>
        <button mat-stroked-button routerLink="/collect_form">Record Data</button>
        <button mat-stroked-button (click)="accountService.signOut()">Sign Out</button>
      </mat-card-actions>
    </mat-card>
  </div>
}